module.exports = __webpack_public_path__ + "media/packs/users/img/footer/fa-bell-solid-5cd2adb959f973263c3487e55c54814f.svg";